import { Image } from 'src/components/common/Image';
import CloseButton from 'src/components/common/close-button/close-button';
import Alert from 'src/components/common/modal/alert/alert';
import { UiKitLoadingButton } from 'src/components/common/ui-kit-loading-button';

import styles from './payment-retry-declined-modal.module.scss';

type Props = {
  isLoading?: boolean;
  onClose: () => void;
  onRetry: () => void;
  show: boolean;
};

export const PaymentRetryDeclinedModal = ({
  isLoading = false,
  onClose,
  onRetry,
  show,
}: Props) => (
  <Alert
    canClose={false}
    show={show}
    onHide={onClose}
    modalContentClassName={styles.modalContent}
  >
    <CloseButton className={styles.closeButton} onClick={onClose} />
    <div className={styles.imageWrapper}>
      <Image src="card-error.webp" fill alt="card-error" />
    </div>
    <h2 className={styles.title}>Oops, just a quick hiccup!</h2>
    <p className={styles.description}>
      Your payment didn&apos;t go through, but it&apos;s usually just a
      temporary glitch. Let&apos;s try again - it often works on the second try.
    </p>
    <UiKitLoadingButton
      className={styles.retryButton}
      data-testid="stripe-retry-payment-button"
      disabled={isLoading}
      loading={isLoading}
      onClick={onRetry}
      type="button"
    >
      Retry
    </UiKitLoadingButton>
  </Alert>
);
